<mat-slide-toggle (change)="changeTheme()" [checked]="checked">
</mat-slide-toggle>